import React from 'react';
import { styled } from '@material-ui/core/styles';

import PreJoinScreens from './components/PreJoinScreens/PreJoinScreens';
import useHeight from './hooks/useHeight/useHeight';

const Container = styled('div')({
  display: 'grid',
  gridTemplateRows: '1fr auto',
});

export default function App() {
  const height = useHeight();

  return (
    <Container style={{ height }}>
      <PreJoinScreens />
    </Container>
  );
}
